var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.99985C2.5 9.45854 3.07946 10.8575 4.11091 11.8889C5.14236 12.9204 6.54131 13.4999 8 13.4999C9.45869 13.4999 10.8576 12.9204 11.8891 11.8889C12.9205 10.8575 13.5 9.45854 13.5 7.99985C13.5 6.54116 12.9205 5.14222 11.8891 4.11077C10.8576 3.07932 9.45869 2.49985 8 2.49985C6.54131 2.49985 5.14236 3.07932 4.11091 4.11077C3.07946 5.14222 2.5 6.54116 2.5 7.99985Z",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.71877a320f3d5fb878fc60377fd4cfb3.svg";
export { ForwardRef as ReactComponent };